import React from 'react';
import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Small } from '@finect/tabular-core/Small';
import { Strong } from '@finect/tabular-core/Strong';
import { getFont } from '@finect/tabular-utils/getFont';
import graphRetirement from '../../assets/graphRetirement.svg';
import graphSavings from '../../assets/graphSavings.svg';

const SidePill = styled.div`
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'center')};

  small {
    padding: 0 9px;
  }
`;

const SidePillInner = styled.div`
  padding: 15px;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.colors.uiLL};
  ${getFont(0)};

  p {
    padding-bottom: 18px;
    padding-left: 24px;
    text-align: center;

    span {
      color: ${({ theme }) => theme.secondaryColor};
    }
  }

  svg {
    color: ${({ theme }) => theme.secondaryColor};
  }

  img {
    display: block;
    margin-bottom: 18px;
  }

  a {
    color: ${({ theme }) => theme.colors.fontL};
    text-decoration: underline;
  }
`;

export const SidePillRetirement = () => (
  <SidePill textAlign="right">
    <SidePillInner>
      <p>
        <Strong>
          Actualmente, el sueldo medio en españa es de 1.636 €/mes y la pensión media de <span>1.074</span> €/mes.
        </Strong>
      </p>
      <img src={graphRetirement} alt="Previsión jubilación" />
    </SidePillInner>
    <Small light>
      {/* Quieres conocer tu pensión,{' '}
      <AppLink href="https://www.finect.com/pills/es_ES/finect/default/calcula-tu-pension">haz tu cálculo</AppLink>. */}
    </Small>
  </SidePill>
);

export const SidePillSavings = () => (
  <SidePill textAlign="right">
    <SidePillInner>
      <p>
        <Strong>
          Ahorrando 500€ cada mes con un perfil moderado podrías llegar a ahorrar <span>227.213€</span> en 20 años.
        </Strong>
      </p>
      <img src={graphSavings} alt="Previsión del ahorro" />
    </SidePillInner>
    <Small light>
      <AppLink href="https://www.finect.com/pildoras/cuanto-tendras-segun-riesgo-asumido">Haz tu cálculo</AppLink>
    </Small>
  </SidePill>
);
